import { commonFunctions } from "../_utilities/commonFunctions";
import { configs } from "../config";
import { configes } from "../webData";

export const faqService = {
  getFaqDetails,
};


function getFaqDetails() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getFaqs/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}
